import { library as faLibrary } from '@fortawesome/fontawesome-svg-core'
import {
	/* list of font awesome icons to make available */
	faLocationArrow,
	faAngleDown,
	faAngleUp,
	faArrowRight,
	faExchangeAlt,
	faInfoCircle,
	faExclamationCircle
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
	install(Vue, options) {
		if (!options.componentName) {
			throw new Error('Invalid value')
		}

		// Load icon set
		faLibrary.add(faLocationArrow, faAngleDown, faAngleUp, faArrowRight, faExchangeAlt, faInfoCircle, faExclamationCircle)

		// Globally register component
		Vue.component(options.componentName, FontAwesomeIcon)
	}
}
